import React, { memo } from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PromptType, PromptProps } from '../types';

const PromptButton = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.divider}`,
  textTransform: 'none',
  fontSize: '0.9rem',
  fontWeight: 500,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const Prompt: React.FC<PromptProps> = memo(({
  prompt,
  onClick,
  disabled = false,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onClick(prompt);
    }
  };

  const displayText = typeof prompt === 'string' 
    ? prompt 
    : prompt.text;

  return (
    <PromptButton
      onClick={handleClick}
      disabled={disabled}
      variant="outlined"
    >
      {prompt.text}
    </PromptButton>
  );
});

Prompt.displayName = 'Prompt';

